module.exports = __webpack_public_path__ + "static/media/vaccine_slider_phone3.f5822502.png";